import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        container: {
            '& .MuiCard-root': {
                marginBottom: theme.spacing(2),
            },
        },
    }
})
